import React from "react";
import {Typography} from "antd";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import {LinkOutlined} from "@ant-design/icons";
import {
    PLATFORM_COLORS,
    PLATFORM_GRADIENTS,
    PLATFORM_NAMES
} from "../../../../../constants/constants";
import externalLinkIcon from "../../../../../public/images/external-link-icon.svg";
import {
    EmptyStateContainer,
    EmptyStateIcon,
    ExternalLinkOutlined,
    IntegrationBox,
    IntegrationLinkContainer,
    IntegrationTableContainer,
    IntegrationText
} from "components/customer/customerIntegrationsPage/components/style/CustomerIntegrationsTable.styles";
import {
    IntegrationRow,
    IntegrationsContainer,
    IntegrationsGrid,
    IntegrationTabContainer
} from "../style/IntegrationsTab.style";

const {Text} = Typography;

export const IntegrationsTab = observer(({activeIntegrationUrls = []}) => {
    const {t} = useTranslation(["common"]);

    // Platform renklerini al
    const getPlatformColor = platform => {
        const upperPlatform = platform.toUpperCase();
        return PLATFORM_COLORS?.[upperPlatform] || PLATFORM_COLORS.DEFAULT;
    };

    return (
        <IntegrationTabContainer>
            {activeIntegrationUrls &&
            Array.isArray(activeIntegrationUrls) &&
            activeIntegrationUrls.length > 0 ? (
                <IntegrationsGrid>
                    {activeIntegrationUrls.map((integration, index) => {
                        const platformColor = getPlatformColor(integration.platform);

                        const handleClick = () => {
                            window.open(integration.url, "_blank");
                        };

                        return (
                            <IntegrationRow
                                key={index}
                                platformColor={platformColor}
                                onClick={handleClick}
                                title={`${integration.platform.toUpperCase()} - ${integration.url}`}
                            >
                                <IntegrationText platformColor={platformColor}>
                                    {PLATFORM_NAMES?.[integration?.platform]}
                                </IntegrationText>
                                <IntegrationLinkContainer>
                                    Paneli ziyaret et.
                                    <ExternalLinkOutlined src={externalLinkIcon} />
                                </IntegrationLinkContainer>
                            </IntegrationRow>
                        );
                    })}
                </IntegrationsGrid>
            ) : (
                <EmptyStateContainer>
                    <Text type="secondary" style={{fontSize: "16px"}}>
                        Bu alt firma için entegrasyon bulunmamaktadır.
                    </Text>
                </EmptyStateContainer>
            )}
        </IntegrationTabContainer>
    );
});
